import { createContext, useContext, useState, useEffect } from "react";
import { isMobile } from "../utils/helpers";
const ScreenContext = createContext();

export function ScreenProvider({ children }) {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  const mobileDevice = isMobile();
  useEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  let contextData = {
    mobileDevice,
    size,
  };
  return (
    <ScreenContext.Provider value={contextData}>
      {children}
    </ScreenContext.Provider>
  );
}

export default function useScreenSize() {
  return useContext(ScreenContext);
}
